import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllProvider = () => {
  return Api(endPoints.getAllProvider, requestType.GET);
};
const searchProviderData = (startDate, endDate) => {
  console.log(startDate, endDate, "startDateendDate");
  return Api(
    `${endPoints.getAllProvider}?startDate=${startDate}&endDate=${endDate}`,
    requestType.GET
  );
};

export { getAllProvider, searchProviderData };
